export default {
  VIEW_BATCH_TO_APPROVE: 'VIEW_BATCH_TO_APPROVE',
  DEFAULT_VIEW_BATCH: 'DEFAULT_VIEW_BATCH',
  VIEW_BATCH_WAITING_TO_RECEIVE: 'VIEW_BATCH_WAITING_TO_RECEIVE',
  BATCH_WIZARD: 'BATCH_WIZARD'
};
